import keys from 'i18n/keys';
import { SIMULATOR_INTRO_STEPS } from './consts';
import type { DriverStep } from 'tour/useDriverTour';
import type { TFunction } from 'i18next';

// jeśli jakieś tłumaczenia zawierają HTML, na start je odetnijmy:
const stripHtml = (s: string) => s.replace(/<[^>]*>/g, '');

export function buildTourSteps(t: TFunction): DriverStep[] {
  return [
    {
      element: 'body',
      popover: {
        title: t(keys.INTRO_STEP_START_title as string),
        description: t(keys.INTRO_STEP_START as string),
        align: 'center',
      },
      padding: 8,
    },
    {
      element: `#${SIMULATOR_INTRO_STEPS.ENERGY_SOURCES}`,
      popover: {
        title: stripHtml(t(keys.INTRO_STEP_ENERGY_SOURCES_title as unknown as string)),
        description: stripHtml(t(keys.INTRO_STEP_ENERGY_SOURCES as unknown as string)),
        align: 'center',
      },
      padding: 8,
    },
    {
      element: `#${SIMULATOR_INTRO_STEPS.DEMAND}`,
      popover: {
        title: stripHtml(t(keys.INTRO_STEP_DEMAND_title as unknown as string)),
        description: stripHtml(t(keys.INTRO_STEP_DEMAND as unknown as string)),
        side: 'right',
        align: 'center',
      },
      padding: 8,
    },
    {
      element: `#${SIMULATOR_INTRO_STEPS.STORAGE}`,
      popover: {
        title: stripHtml(t(keys.INTRO_STEP_STORAGE_title as unknown as string)),
        description: stripHtml(t(keys.INTRO_STEP_STORAGE as unknown as string)),
        side: 'right',
        align: 'center',
      },
      padding: 8,
    },
    {
      element: `#${SIMULATOR_INTRO_STEPS.HYDROGEN}`,
      popover: {
        title: stripHtml(t(keys.INTRO_STEP_HYDROGEN_title as unknown as string)),
        description: stripHtml(t(keys.INTRO_STEP_HYDROGEN as unknown as string)),
        align: 'center',
      },
      padding: 8,
    },
    {
      element: `#${SIMULATOR_INTRO_STEPS.DISPOSAL_SOURCES}`,
      popover: {
        title: stripHtml(t(keys.INTRO_STEP_DISPOSAL_SOURCES_title as unknown as string)),
        description: stripHtml(t(keys.INTRO_STEP_DISPOSAL_SOURCES as unknown as string)),
        align: 'center',
      },
      padding: 8,
    },
    {
      element: `#${SIMULATOR_INTRO_STEPS.CONSTRUCTION_COSTS}`,
      popover: {
        title: stripHtml(t(keys.INTRO_STEP_CONSTRUCTION_COSTS_title as unknown as string)),
        description: stripHtml(t(keys.INTRO_STEP_CONSTRUCTION_COSTS as unknown as string)),
        align: 'center',
      },
      padding: 8,
    },
    {
      element: `#${SIMULATOR_INTRO_STEPS.BILANS_OGRZEWANIA}`,
      popover: {
        title: stripHtml(t(keys.INTRO_STEP_HEAT_BALANCE_title as unknown as string)),
        description: stripHtml(t(keys.INTRO_STEP_HEAT_BALANCE as unknown as string)),
        align: 'center',
      },
      padding: 8,
    },
    {
      element: `#${SIMULATOR_INTRO_STEPS.ELEKTROLIZA}`,
      popover: {
        title: stripHtml(t(keys.INTRO_STEP_ELEKTROLYZE_title as unknown as string)),
        description: stripHtml(t(keys.INTRO_STEP_ELEKTROLYZE as unknown as string)),
        align: 'center',
      },
      padding: 8,
    },
    {
      element: `#${SIMULATOR_INTRO_STEPS.ENERGY_BALANCE}`,
      popover: {
        title: stripHtml(t(keys.INTRO_STEP_ENERGY_BALANCE_title as unknown as string)),
        description: stripHtml(t(keys.INTRO_STEP_ENERGY_BALANCE as unknown as string)),
        align: 'center',
      },
      padding: 8,
    },
    {
      element: `#${SIMULATOR_INTRO_STEPS.LINE_CHART}`,
      popover: {
        title: stripHtml(t(keys.INTRO_STEP_LINE_CHART_title as unknown as string)),
        description: stripHtml(t(keys.INTRO_STEP_LINE_CHART as unknown as string)),
        side: 'left',
        align: 'center',
      },
      padding: 8,
    },
    {
      element: `#${SIMULATOR_INTRO_STEPS.EXPORT_PDF}`,
      popover: {
        title: stripHtml(t(keys.INTRO_STEP_EXPORT_title as unknown as string)),
        description: stripHtml(t(keys.INTRO_STEP_EXPORT as unknown as string)),
        align: 'center',
      },
      padding: 8,
    },
    {
      element: `#${SIMULATOR_INTRO_STEPS.EXPORT_DATA}`,
      popover: {
        title: stripHtml(t(keys.INTRO_STEP_EXPORT_DATA_title as unknown as string)),
        description: stripHtml(t(keys.INTRO_STEP_EXPORT_DATA as unknown as string)),
        align: 'center',
      },
      padding: 8,
    },
    {
      element: `#${SIMULATOR_INTRO_STEPS.CHOOSE_SCENARIO}`,
      popover: {
        title: stripHtml(t(keys.INTRO_STEP_CHOOSE_SCENARIO_title as unknown as string)),
        description: stripHtml(t(keys.INTRO_STEP_CHOOSE_SCENARIO as unknown as string)),
        align: 'center',
      },
      padding: 8,
    },
    {
      element: `#${SIMULATOR_INTRO_STEPS.ADVANCED_DATA}`,
      popover: {
        title: stripHtml(t(keys.INTRO_STEP_ADVANCED_DATA_title as unknown as string)),
        description: stripHtml(t(keys.INTRO_STEP_ADVANCED_DATA as unknown as string)),
        align: 'center',
      },
      padding: 8,
    },
    {
      element: `#${SIMULATOR_INTRO_STEPS.SAVE_SIMULATION}`,
      popover: {
        title: stripHtml(t(keys.INTRO_STEP_SAVE_SIMULATION_title as unknown as string)),
        description: stripHtml(t(keys.INTRO_STEP_SAVE_SIMULATION as unknown as string)),
        align: 'center',
      },
      padding: 8,
    },
    {
      element: `#${SIMULATOR_INTRO_STEPS.CHOOSE_YEAR}`,
      popover: {
        title: stripHtml(t(keys.INTRO_STEP_CHOOSE_YEAR_title as unknown as string)),
        description: stripHtml(t(keys.INTRO_STEP_CHOOSE_YEAR as unknown as string)),
        align: 'center',
      },
      padding: 8,
    },
    {
      element: 'body',
      popover: {
        title: stripHtml(t(keys.INTRO_STEP_TUTORIAL_title as unknown as string)),
        description: stripHtml(t(keys.INTRO_STEP_TUTORIAL as unknown as string)),
        align: 'center',
      },
      padding: 8,
    },
  ];
}
